module.exports = __webpack_public_path__ + "img/hero-dog.d612534f.webp";